import React, { useState,useEffect, useMemo} from 'react';
import { Modal, Form, Button, CloseButton } from '@deere/ux.uxframe-react';
import { useTranslation } from "react-i18next"; 
import { ReactComponent as ExcelIcon } from "@deere/ux.brand-foundations/icons/excel.svg";
import { excelPartsExport } from '../../utils/downloadUtils';
import { CM_RESPONSE_STATUS, PART_POPUP_HEADER, PART_POPUP_ACCESSOR_KEYS, EWDC, PART_FIRST_NAME_COLUMN, PART_RACF_COLUMN, addCol1, addCol1Accessor, addCol2Accessor } from '../../utils/surveyLiterals';
import { ModalGeneric } from '../../components/ModalGeneric';
import { DataTable } from '../../components/details/DataTable';


export const PartPopUp = ({ show, handleClose, assignmentId,  campaign, partFunc, survey, isAuthMethodOkta, token, defaultColumns }) => {

    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [downloading, setDownloading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const additionalCols = defaultColumns.filter((ac) => ac.isNonDeere === campaign.isNonDeere && ac.defaultColumnMapping && ac.defaultColumnMapping !== "");

    const columns = useMemo(
        () => {
                return [
                    {
                        Header: survey.code === EWDC ? PART_FIRST_NAME_COLUMN : campaign.isNonDeere? PART_POPUP_HEADER.PART : PART_POPUP_HEADER.DEEREPART,
                        accessor: campaign.isNonDeere ? PART_POPUP_ACCESSOR_KEYS.PART : PART_POPUP_ACCESSOR_KEYS.DEEREPART,
                        id:'deerePartShow'
                    },
                    {
                        Header: PART_POPUP_HEADER.DECLARED,
                        accessor: PART_POPUP_ACCESSOR_KEYS.DECLARED
                    }
                ]
        },
        [data]
    )
    if (survey.code === EWDC) {
        columns.push({Header: PART_RACF_COLUMN, accessor: PART_POPUP_ACCESSOR_KEYS.HSCODE});
    } else {
        additionalCols.forEach((dc) => {
            if (dc.defaultColumnMapping === addCol1)
              columns.push({ Header: dc.columnNames, accessor: addCol1Accessor });
            else 
              columns.push({ Header: dc.columnNames, accessor: addCol2Accessor });
        });
    }

    let surveyCode = campaign && campaign.surveyCode ? campaign.surveyCode : survey && survey.code ? survey.code : "";
    
    const handleExcelDownload = e => {
        try {
            setDownloading(true)
            excelPartsExport(data,columns,assignmentId,[{Header: 'Delete'}, {Header:'Deere Part Description'}], surveyCode, campaign.isNonDeere, survey.templateType, additionalCols);
            setDownloading(false)
        }
        catch (err) {
            setDownloading(false)
            throw err
        }
    }
    
    const handleClosePopUp=()=>{
        handleClose(false);
    }

    const loadData= ()=>{
        partFunc(assignmentId, token, campaign.isNonDeere, isAuthMethodOkta).then(response =>{
                if(response && Array.isArray(response)){                    
                    response.forEach(part =>{
                        part.declared = part.statusResponse === CM_RESPONSE_STATUS.SUBMITTED ?'Yes':'No'
                          
                    })
                    setData([...response]);
                } else{
                    console.log("No parts availble");
                    setData([]);
                } 
            }).catch(error => {
                console.log(error);
            })
    }

    useEffect(() => {
        if (!data || data.length <= 0) {
            loadData()
        }
    }, [data.length]);

    return (
        <Modal  size='lg' show ={show}>
                <Modal.Header>
                    <Modal.Title>{survey.code === EWDC ? "Employee Count" : "Part Count"}</Modal.Title>
                    <CloseButton onClick={handleClosePopUp}/>
                </Modal.Header>
                <Modal.Body scrollable='true' style={{height: '350px',overflowY: "auto"}}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 'bold' }}>
                            Request Number {assignmentId}
                        </Form.Label>
                    </Form.Group>
                    <Form.Group>
                      <DataTable data={data} columns={columns} />
                    </Form.Group>
                     <ModalGeneric showModal={showModal}
                            setShowModal={setShowModal}
                            labelBtnPrimary={t('t2_remove')}
                            labelBtnSecondary={t('btn_cancel')}
                            handleSubmit={()=>{}}
                            msgModal={t('modal_generic_msg')}
                            titleModal={t('t2_remove')}
                        />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClosePopUp} variant="secondary">Close</Button>
                    {
                        downloading || !data || data.length <1?null:<Button variant="outline-success" onClick={handleExcelDownload}> <ExcelIcon size='sm' /> {'Download'} </Button>
                    }
                </Modal.Footer>
            </Modal>
           
    )
}